
// You can write more code here

/* START OF COMPILED CODE */

import { Sounds } from "../../sounds";
import UserComponent from "../core/UserComponent";
import Phaser from "phaser";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class TazGameReaction extends UserComponent {

	constructor(gameObject: Phaser.GameObjects.Image) {
		super(gameObject);

		this.gameObject = gameObject;
		(gameObject as any)["__TazGameReaction"] = this;

		/* START-USER-CTR-CODE */
		// Write your code here.
		/* END-USER-CTR-CODE */
	}

	static getComponent(gameObject: Phaser.GameObjects.Image): TazGameReaction {
		return (gameObject as any)["__TazGameReaction"];
	}

	private gameObject: Phaser.GameObjects.Image;

	/* START-USER-CODE */
	private time:number = 0;
	private timeSinceSlowDownReact:number = 0;
	private timeSinceHitReact:number = 0;
	private resetTimer:number = 0;
	private shownSlowDownReaction:boolean = false;

	public ReactSlowDown()
	{
		if(this.time-this.timeSinceSlowDownReact > 2000 && !this.shownSlowDownReaction)
		{
			this.timeSinceSlowDownReact = this.time;
			this.gameObject.setTexture(this.gameObject.texture.key,"taz-3.png");
			this.resetTimer = 0;
			this.shownSlowDownReaction = true;
			this.scene.app.AudioHandler.playSound(this.scene, Sounds.Track.TazHappyWoah, Sounds.Channel.SFX, { volume: 1});
		}
	}

	public ReactIdle()
	{
		// if(this.time-this.timeSinceSlowDownReact > 2000 && !this.shownSlowDownReaction)
		// {
			// this.timeSinceSlowDownReact = this.time;
			this.gameObject.setTexture(this.gameObject.texture.key,"taz-3.png");
			this.resetTimer = 0;
			// this.shownSlowDownReaction = true;
			// this.scene.app.AudioHandler.playSound(this.scene, Sounds.Track.TazHappyWoah, Sounds.Channel.SFX, { volume: 1});
		// }
	}

	public ReactHit()
	{
		if(this.time-this.timeSinceHitReact > 2000)
		{
			this.timeSinceHitReact = this.time;
			this.gameObject.setTexture(this.gameObject.texture.key,"taz-2.png");
			this.resetTimer = 0;
		}
	}

	protected update(time: number, delta: number): void {
		this.time = time;
		this.resetTimer += delta;
		if(this.resetTimer > 1000)
		{
			this.gameObject.setTexture(this.gameObject.texture.key,"taz-1.png");
		}
	}

	public Reset()
	{
		this.shownSlowDownReaction = false;
	}

	/* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
